<template>
  <div id="app" style="height: 100vh; overflow-x: hidden">
    <div>
      <!-- 加载动画 -->
      <div class="loads" v-show="isload">
        <dv-loading style="width: 250px; height: 250px">Loading...</dv-loading>
      </div>
      <div class="prductCategory">
        <el-dropdown @command="selectProduct" trigger="click">
          <span style="color: white" class="el-dropdown-link">
            产线筛选：{{ product["uuid"] ? product["title"] : "所有产线"
            }}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="''">所有产线</el-dropdown-item>
            <el-dropdown-item :command="item" v-for="(item, i) in productList" :key="i">{{ item.title
            }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="time">
        <div style="margin-top: -10px">
          <el-date-picker style="width: 5rem" size="mini" v-model="dateFilter" type="daterange" start-placeholder="开始"
            end-placeholder="结束" :picker-options="pickerOptions" @change="dateFilterWhere()">
          </el-date-picker>
        </div>
        <div style="margin-top: 5px; text-align: right">
          {{ now }} {{ week }}
        </div>
      </div>
      <div @click="signOut" class="power">
        <i style="cursor: pointer" class="el-icon-back"></i>
      </div>
      <div class="logoImg">
        <img style="height: 0.8rem" :src="logoSrc" />
      </div>
      <header class="w-100 flex j-center a-center">
        <dv-decoration-5 :dur="10" style="position: absolute; bottom: 0; right: 0; height: 50%" class="w-100" />
        <div class="font-big font-weight">
          {{ kanban["title"] ? kanban["title"] : "安灯报警模块看板" }}
        </div>
      </header>
    </div>
    <div class="p">
      <el-row :gutter="12">
        <template v-for="(item, i) in kanbanCard">
          <el-col v-if="item['id'] == 'deviceTotal'" :key="i" :span="item['col']">
            <deviceTotal :col="item.height" :headTitle="item.title" :deviceBean="deviceBean" />
          </el-col>
          <el-col v-if="item['id'] == 'weekHourLoss'" :key="i" :span="item['col']">
            <weekHourLoss :col="item.height" :headTitle="item.title" :hours="weekHour" />
          </el-col>
          <el-col v-if="item['id'] == 'stationPlato'" :key="i" :span="item['col']">
            <stationPlato :col="item.height" :headTitle="item.title" :plato="stationPlato" />
          </el-col>
          <el-col v-if="item['id'] == 'alertList'" :key="i" :span="item['col']">
            <alertList :col="item.height" :tasks="taskList" />
          </el-col>
          <el-col v-if="item['id'] == 'mtbfWidget'" :key="i" :span="item['col']">
            <mtbfWidget :col="item.height" :headTitle="item.title" :mtbf="mtbf" />
          </el-col>
          <el-col v-if="item['id'] == 'mttrWidget'" :key="i" :span="item['col']">
            <mttrWidget :col="item.height" :headTitle="item.title" :mttr="mttr" :mtbf="mtbf" />
          </el-col>
          <el-col v-if="item['id'] == 'deviceCategory'" :key="i" :span="item['col']">
            <deviceCategory :col="item.height" :headTitle="item.title" :typeBean="category" />
          </el-col>
          <el-col v-if="item['id'] == 'productLinePloat'" :key="i" :span="item['col']">
            <productLinePlato :col="item.height" :headTitle="item.title" :plato="linePlatoList" />
          </el-col>
          <el-col v-if="item['id'] == 'productLineLoss'" :key="i" :span="item['col']">
            <productionLoss :col="item.height" :headTitle="item.title" :hours="productLineHour" />
          </el-col>
          <el-col v-if="item['id'] == 'stationLoss'" :key="i" :span="item['col']">
            <stationLoss :col="item.height" :headTitle="item.title" :hours="stationHour" />
          </el-col>
          <el-col v-if="item['id'] == 'productLineMTTR'" :key="i" :span="item['col']">
            <productionMttr :col="item.height" :headTitle="item.title" :mttr="productMttr" />
          </el-col>
          <el-col v-if="item['id'] == 'productLineMTBF'" :key="i" :span="item['col']">
            <productionMtbf :col="item.height" :headTitle="item.title" :mtbf="productMtbf" />
          </el-col>
        </template>
      </el-row>
    </div>
    <audio></audio>
  </div>
</template> 

<script>
import API from "@/utils/api";
import router from "../../../router";
import format from "date-fns/format";
import deviceCategory from "../component/device-category.vue";
import weekHourLoss from "../component/week-hour-loss.vue";
import stationPlato from "../component/station-plato.vue";
import mttrWidget from "../component/mttr.vue";
import mtbfWidget from "../component/mtbf.vue";
import deviceTotal from "../component/device-total.vue";
import alertList from "../component/alert-list.vue";
import productLinePlato from "../component/productline-plato.vue";
import productionLoss from "../component/production-loss.vue";
import stationLoss from "../component/station-loss.vue";
import productionMttr from "../component/production-mttr.vue";
import productionMtbf from "../component/production-mtbf.vue";
export default {
  name: "andon-board-app",
  components: {
    deviceCategory,
    weekHourLoss,
    stationPlato,
    mttrWidget,
    mtbfWidget,
    deviceTotal,
    alertList,
    productLinePlato,
    productionLoss,
    stationLoss,
    productionMttr,
    productionMtbf,
  },
  data() {
    return {
      hoursTime: undefined,
      kanbanSelf: false,
      colSpan: 28,
      isload: false,
      websock: null,
      kanban: {},
      kanbanCard: [{}],
      reconnectData: null,
      lockReconnect: false,
      category: [],
      deviceList: [],
      taskList: [],
      productList: [],
      product: {},
      now: null,
      week: null,
      weekHour: [],
      productLineHour: [],
      stationPlato: [],
      stationHour: [],
      linePlatoList: [],
      mttr: [],
      mtbf: [],
      productMtbf: [],
      productMttr: [],
      logoSrc: "/assets/img/logo_light.png",
      audioSrc: require("@/assets/mp3/alert.mp3"),
      deviceBean: {
        confirm: 0,
        pending: 0,
        process: 0,
        evaluate: 0,
        count: 0,
        power: 0,
        errorCount: 0,
      },
      dateFilter: null,
      loodIndex: 0,
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近两周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 14);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近两个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 60);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一年",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },

  mounted() {
    this.webSocket();
    this.loadData();
    this.loadProductLine();
    //钟表
    this.clockTime=setInterval(this.clock, 1000);

    //自动切换损失分类图
    this.hoursTime = setInterval(this.loadHourData, 60000);
  },
  created() {
    this.isload = true;
    this.getDesign();
  },
  destroyed() {
    if (this.websock) {
      this.lockReconnect = true;
      this.websock.close();
    }
    if (this.clockTime) {
      clearInterval(this.clockTime);
    }
    if (this.hoursTime) {
      clearInterval(this.hoursTime);
    }
  },
  methods: {
    play() {
      var task = this.taskList;
      var now = new Date().getTime();
      for (var i = 0; i < task.length; i++) {
        var afterDate = now - task[i]["createdTime"];
        //两分钟内，定义为新异常
        if (task[i]["status"] == 0 && afterDate <= 1000 * 60 * 2) {
          var audios = new Audio(this.audioSrc);
          audios.controls = false;
          audios.play();
          setTimeout(() => {
            audios.play();
          }, 3000);
          break;
        }
      }
    },
    signOut() {
      router.back();
    },
    selectProduct(item) {
      this.product = item || {};
      this.isload = true;
      this.loadData();
    },
    dateFilterWhere() {
      this.isload = true;
      this.loadData();
    },
    getDesign() {
      var user = localStorage.getItem("user_session");
      if (user == null) {
        router.push("/login");
        this.isload = false;
        return;
      } else {
        var kanbanSelf = localStorage.getItem("kaban_self");
        console.log(kanbanSelf);

        if (kanbanSelf == null || kanbanSelf == "false") {
          // 未开启自定义看板
          var card = [
            { id: "deviceTotal", height: 28, col: 8, title: "设备总览" },
            { id: "weekHourLoss", height: 28, col: 8, title: "周工时损耗" },
            { id: "stationPlato", height: 28, col: 8, title: "工位柏拉图" },
            { id: "alertList", height: 28, col: 24, title: "报警列表" },
            { id: "deviceCategory", height: 28, col: 8, title: "设备分类" },
            { id: "mtbfWidget", height: 28, col: 8, title: "MTBF" },
            { id: "mttrWidget", height: 28, col: 8, title: "MTTR" },
          ];
          this.kanbanCard = card;
          return;
        }

        API.getDesign({ module: "andon" })
          .then((res) => {
            if (res.success == true) {
              var kanban = res.value;
              if (kanban != null) {
                this.kanbanCard = kanban["designList"];
                this.kanban = kanban;
              }
            } else {
              this.$message.error(res.message);
            }
          })
          .catch((error) => {
            this.$message.error("网络错误,数据查询失败");
          });
      }
    },
    loadData() {
      var user = localStorage.getItem("user_session");
      if (user == null) {
        router.push("/login");
        this.isload = false;
        return;
      } else {
        user = JSON.parse(user);
        sessionStorage.setItem("token", user.token);
        sessionStorage.setItem("http", user.http);

        var params = { productLine: this.product["uuid"] };

        if (this.dateFilter != null) {
          params["startTime"] = this.dateFilter[0].getTime();
          params["endTime"] = this.dateFilter[1].setHours(23, 59, 59, 0);
        }

        API.loadTheme().then((re) => {
          if (re.success && re["list"].length > 0) {
            this.logoSrc = re["list"][0]["icon"];
          }
        });

        API.loadData(params)
          .then((res) => {
            this.isload = false;
            if (res.success === true) {
              this.taskList = res["list"];
              this.deviceList = res["deviceList"];
              this.weekHour = res["hours"];
              this.productLineHour = res["productLineHour"];
              this.stationHour = res["stationHour"] || [];
              this.category = res["categorys"];
              this.stationPlato = res["plato"];
              this.linePlatoList = res["productLinePlato"];
              this.mttr = res["mttr"];
              this.mtbf = res["mtbf"];
              this.productMttr = res["productMttr"] || [];
              this.productMtbf = res["productMtbf"] || [];
              Object.keys(this.deviceBean).forEach((key) => {
                this.deviceBean[key] = res[key];
              });

              this.play();
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    loadHourData() {
      var user = localStorage.getItem("user_session");
      if (user == null) {
        router.push("/login");
        return;
      } else {
        user = JSON.parse(user);
        sessionStorage.setItem("token", user.token);
        sessionStorage.setItem("http", user.http);
        var params = { productLine: this.product["uuid"] };
        if (this.dateFilter != null) {
          return;// 有筛选，不再切换
        } else {
          var index = this.loodIndex;
          const end = new Date().getTime();
          const start = new Date();
          if (index == 0) {
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
          } else if (index == 1) {
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 14);
          } else if (index == 2) {
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
          } else if (index == 3) {
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 60);
          } else if (index == 4) {
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
          } else if (index == 5) {
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 356);
          }
          params["startTime"] = start.getTime();
          params["endTime"] = end;
          index < 5 ? (this.loodIndex += 1) : (this.loodIndex = 0);
        }
        API.loadAndonHourData(params)
          .then((res) => {
            this.isload = false;
            if (res.success === true) {
              this.weekHour = res["list"];
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    loadProductLine() {
      var user = localStorage.getItem("user_session");
      if (user == null) {
        router.push("/login");
        this.isload = false;
        return;
      } else {
        API.loadProductLine()
          .then((res) => {
            if (res.success === true) {
              this.productList = res["list"];
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    webSocket() {
      var http = sessionStorage.getItem("http");
      if (http) {
        http += "/websocket/andon/monitoring";
      } else {
        http = "https://demo.biqs.cn/websocket/andon/monitoring";
      }

      http = http.replace("https", "wss").replace("http", "ws");

      this.websock = new WebSocket(http);
      this.websock.onopen = this.websocketonopen; //连接成功
      this.websock.onmessage = this.websocketonmessage; //广播成功
      this.websock.onerror = this.websocketonerror; //连接断开，失败
      this.websock.onclose = this.websocketclose;

      let this_ = this;
    },
    //连接成功
    websocketonopen() {
      console.log("安灯socket连接成功");
    },

    //连接失败
    websocketonerror() {
      console.log("安灯socket连接失败");
      this.reconnect();
    },

    //各种问题导致的 连接关闭
    websocketclose() {
      console.log("安灯socket断开连接");
      this.reconnect();
    },
    //数据接收
    websocketonmessage(data) {
      console.log(data);
      //刷新
      this.loadData();
    },

    //断开重连
    reconnect() {
      if (this.lockReconnect) {
        return;
      }
      this.reconnectData && clearTimeout(this.reconnectData);
      this.reconnectData = setTimeout(() => {
        this.webSocket();
      }, 5000);
    },
    clock() {
      //全局变量d，创建Date对象
      var d = new Date();
      //格式：2018-2-5  19:19:33
      this.now = format(d, "yyyy-MM-dd HH:mm:ss");
      var week = new Array(
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六"
      )[d.getDay()];
      this.week = week;
    },
  },
};
</script>
<style scoped>
#app {
  background: url("../../../assets/img/bg2.png");
}

.prductCategory {
  color: white;
  position: absolute;
  right: 25%;
  top: 20px;
  z-index: 999999;
}

.loads {
  background: #06164a;
  z-index: 999;
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0%;
  top: 0%;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
}

header {
  background: url("../../../assets/img/head_bg.png");
  background-size: 100% 100%;
  position: relative;
  height: 10vh;
}

/* 媒体查询  */
@media screen and (max-width: 1024px) {
  html {
    font-size: 42px !important;
  }
}

@media screen and (min-width: 1920px) {
  html {
    font-size: 80px !important;
  }
}

/* 主题色 */
.color-blue {
  color: #1fe9e8;
}

.color-gray {
  color: #cdeaf6;
}

.logoImg {
  position: absolute;
  left: 80px;
  top: 0px;
  font-size: 22px;
  z-index: 999;
}

.el-input__inner {
  background-color: black !important;
  border-radius: 0 !important;
}
</style>
<style scoped src='./board.css'></style>



// WEBPACK FOOTER //
// src/pages/andon/board/board.vue